import { z } from 'zod';
export const SucursalFullSchema = z.object({
    id: z.string().uuid(),
    nombre: z.string(),
    direccion: z.string().nullable().optional(),
    telefono: z.string().nullable().optional(),
    email: z.string().nullable().optional(),
    activo: z.boolean(),
    creadoEn: z.string().optional(),
    actualizadoEn: z.string().optional(),
});
export const SucursalFormSchema = z.object({
    nombre: z.string().trim().min(2, 'Mínimo 2').max(150),
    direccion: z.string().max(2000).optional().or(z.literal('')),
    telefono: z.string().max(50).optional().or(z.literal('')),
    email: z.string().email('Email inválido').max(150).optional().or(z.literal('')),
});
export const PuntoVentaFullSchema = z.object({
    id: z.string().uuid(),
    sucursalId: z.string().uuid(),
    nombre: z.string(),
    descripcion: z.string().nullable().optional(),
    activo: z.boolean(),
});
export const PuntoVentaFormSchema = z.object({
    nombre: z.string().trim().min(1, 'Requerido').max(100),
    descripcion: z.string().max(1000).optional().or(z.literal('')),
});
export const PuntoEncuentroFullSchema = z.object({
    id: z.string().uuid(),
    sucursalId: z.string().uuid(),
    nombre: z.string(),
    referencia: z.string().nullable().optional(),
    lat: z.number().nullable().optional(),
    lng: z.number().nullable().optional(),
    activo: z.boolean(),
});
export const PuntoEncuentroFormSchema = z.object({
    nombre: z.string().trim().min(1, 'Requerido').max(150),
    referencia: z.string().max(2000).optional().or(z.literal('')),
    lat: z.string().optional().or(z.literal('')),
    lng: z.string().optional().or(z.literal('')),
});
